<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>子账号信息</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-select :value="queryType" @change="setQueryType" placeholder="请选择">
          <el-option
            v-for="item in queryTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-input
          placeholder="请输入内容"
          clearable
          v-model="queryValue"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <label style="font-size: 16px;">的</label>
        <el-select :value="subType" @change="setSubType" placeholder="请选择">
          <el-option
              v-for="item in subTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <el-button
          type="primary"
          @click="handleSearch"
        >搜索</el-button>
        <el-button type="primary" @click="showAddBindSubDialog">添加绑定子账号</el-button>
      </div>
      <!-- 修改：添加ref引用 -->
      <user-sub-list 
        ref="userSubList"
        @refresh="refreshList"
        @show-add-dialog="showAddBindSubDialog"
      ></user-sub-list>
    </el-card>
  </div>
</template>

<script>
import './store';
import UserSubList from './components/list';
import { mapState, mapActions, mapMutations } from 'vuex';
import { QUERY_TYPE, PAGINATION } from './constants';

export default {
  name: 'UserSub',
  components: {
    UserSubList
  },
  data() {
    return {
      queryValue: ''
    };
  },
  computed: {
    ...mapState('userSub', ['queryType', 'queryTypeList', 'subType', 'subTypeList', 'pagination'])
  },
  methods: {
    ...mapActions('userSub', ['list']),
    ...mapMutations('userSub', ['setQueryType', 'setSubType']),
    refreshList(data = {}) {
      this.list({
        queryType: this.queryType,
        subType: this.subType,
        queryValue: this.queryValue,
        ...this.pagination,
        ...data
      });
    },
    handleSearch() {
      this.list({
        queryType: this.queryType,
        queryValue: this.queryValue,
        subType: this.subType,
        ...PAGINATION
      });
    },
    showAddBindSubDialog() {
      // 修改：确保$refs存在且正确访问子组件
      if (this.$refs.userSubList) {
        this.$refs.userSubList.addBindSubDialogVisible = true;
      }
    }
  }
};
</script>
